import type { ApiRequestFn } from "../../types/api";
import type { CompleteSetupResponse, SetupStatusResponse } from "../../types/setup";

const createSetupApi = (request: ApiRequestFn) => ({
  getStatus: () => request<SetupStatusResponse>("/me/setup/status"),
  complete: () => request<CompleteSetupResponse>("/me/setup/complete", { method: "POST" }),
});

export { createSetupApi };
